import { css } from "@nfront/global-styles";
import theme from "./theme";

const global = css`
    *,
    *::before,
    *::after {
        margin: 0;
        padding: 0;
        border: 0;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        font-family: 'Roboto', sans-serif;
        -webkit-font-smoothin: antialiased;
        -moz-osx-font-smoothing: grayscaled;
    }

    html {
        box-sizing: border-box;
        --color-white: ${theme.colors.white};
        --color-black: ${theme.colors.black};
        --color-darkgrey: ${theme.colors.darkgrey};
        --color-grey: ${theme.colors.grey};
        --color-lightgrey: ${theme.colors.lightgrey};
        --color-blue: ${theme.colors.blue};
        --color-green: ${theme.colors.green};
    }

    body {
        line-height: 1.5;
    }

    a, input, textarea,button {
        outline: none;
        text-decoration: none;
        font-family: inherit;
        color: ${theme.colors.black};
        :focus {
            outline: none;
        }
    } 

    ol, ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, 
    blockquote:after,
    q:before, 
    q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    
`
export default global
